/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypeReview,
  propTypesAltLanguage,
  propTypesFAQContent,
  propTypesIllustration,
} from '../../shared/constants/Proptypes';

export const propTypesPage = {
  last_publication_date: PropTypes.string,
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  prismicId: PropTypes.string,
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    body: PropTypes.shape({}),
    breadcrumb: PropTypes.shape({
      parent_document: PropTypes.shape(propTypesPage),
      parent_name: PropTypes.string,
    }),
    breadcrumb_title: PropTypes.string,
    faq_content: PropTypes.arrayOf(PropTypes.shape(propTypesFAQContent)),
    has_newsletter_section: PropTypes.bool,
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    reviews: PropTypes.arrayOf(PropTypes.shape(propTypeReview)),
  }),
};
